import { useEffect, useState } from 'react';

export default function useProfileData(profileFiles) {
	const [data, setData] = useState({});
	const [platforms, setPlatforms] = useState([]);
	const [expertise, setExpertise] = useState([]);
	const [skills, setSkills] = useState([]);
	const [jobs, setJobs] = useState([]);
	const [links, setLinks] = useState([]);

	useEffect(() => {
		let isMounted = true;

		const fetchContent = async () => {
			try {
				let profileData = null;

				for (const fileName of profileFiles) {
					const response = await fetch(fileName);

					if (!response.ok) {
						continue;
					}

					profileData = await response.json();
					break;
				}

				if (!isMounted || !profileData) {
					return;
				}

				setData(profileData);
				setExpertise(profileData.expertise || []);
				setSkills(profileData.skills || []);
				setPlatforms(profileData.platforms || []);
				setJobs(profileData.jobs || []);
				setLinks(profileData.links || []);
			} catch (error) {
				if (!isMounted) {
					return;
				}

				setData({});
				setExpertise([]);
				setSkills([]);
				setPlatforms([]);
				setJobs([]);
				setLinks([]);
			}
		};

		fetchContent();

		return () => {
			isMounted = false;
		};
	}, [profileFiles]);

	return {
		data,
		platforms,
		expertise,
		skills,
		jobs,
		links
	};
}
